import { gql } from "@apollo/client";

export const UPDATE_SINGLE_ACCOUNT = gql`
  mutation UpdateSingleAccount(
    $id: Int!
    $firstName: String!
    $lastName: String!
    $isTestUser: Boolean!
    $contactPhoneNumber: String
    $activityPhoneNumber: String
    $timeZone: String!
    $summary: String
    $specialistId: Int!
    $bdlProgramStartOn: String
    $bdlProgramEndOn: String
    $leadType: String
    $Id_Ehr: String
    $callDeliverySpeed: CallDeliverySpeed
  ) {
    updateAccount(
      data: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        isTestUser: $isTestUser
        contactPhoneNumber: $contactPhoneNumber
        activityPhoneNumber: $activityPhoneNumber
        timeZone: $timeZone
        summary: $summary
        specialistId: $specialistId
        bdlProgramStartOn: $bdlProgramStartOn
        bdlProgramEndOn: $bdlProgramEndOn
        leadType: $leadType
        Id_Ehr: $Id_Ehr
        callDeliverySpeed: $callDeliverySpeed
      }
    ) {
      id
      firstName
      lastName
      contactPhoneNumber
      activityPhoneNumber
      specialist {
        id
        firstName
        lastName
      }
      timeZone
      summary
      leadType
      Id_Ehr
      callDeliverySpeed
    }
  }
`;

export const QUERY_RESPONSE = gql`
  query GetEditUserModalSpecialists {
    specialists {
      id
      firstName
    }
  }
`;
